import Mail from "../../images/contact-us/mail.png";
import Phone from "../../images/contact-us/phone.png";
import Gradient from "../../images/contact-us/cta-bg.png";
import { useState } from "react";
import emailjs from "@emailjs/browser";

function ContactCta() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [isSending, setIsSending] = useState(false);
  const [feedback, setFeedback] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    setFeedback("");

    try {
      const result = await emailjs.send(
        "service_09pjdic", // EmailJS service ID
        "template_6k1x1tn", // EmailJS template ID
        {
          from_name: formData.name,
          phone: formData.phone,
          reply_to: formData.email,
          message: formData.message,
        },
        "cBfLyi4ijOhMw9xRJ" // EmailJS public key
      );

      setFeedback("Message sent successfully!");
      setFormData({
        name: "",
        phone: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("EmailJS error:", error);
      setFeedback("Failed to send message. Please try again later.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="cta">
      <h1 className="heading">Let's get in touch</h1>
      <img src={Mail} className="mail-img" alt="mail" />
      <p className="mail-text">Send us an Email info@brandonetech.com</p>
      <img src={Phone} className="phone-img" alt="phone" />
      <p className="phone-text">
        You can call us on +234 02014537263 +234 02019049533
      </p>
      <img src={Gradient} className="bg" alt="bg" />
      <form className="form" onSubmit={handleSubmit}>
        <div className="fields">
          <p>Name</p>
          <input
            type="text"
            name="name"
            placeholder="John Doe"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <p>Phone</p>
          <input
            type="tel"
            name="phone"
            placeholder="Your number"
            value={formData.phone}
            onChange={handleChange}
          />
          <p>Email</p>
          <input
            type="email"
            name="email"
            placeholder="john@example.com"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <p>Message</p>
          <textarea
            name="message"
            placeholder="Your Enquiry"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" disabled={isSending}>
          <p>{isSending ? "Sending..." : "Send message"}</p>
          <div />
        </button>
        {feedback && <p style={{ marginTop: "10px" }}>{feedback}</p>}
      </form>
    </div>
  );
}

export default ContactCta;
